var path = 'spinnaker.modules/sla.v2/overrides/shim/shim.template.html';
var html = "<div>\n  <sla-config update-sla-definitions=\"ctrl.updateSLADefinitions\" upstream-sla-definitions=\"ctrl.application.slaDefinitions\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;